import React, { Component, createRef } from 'react';
import axios from 'axios';
import { REGULAR_PATH } from '../../../env';
import {
  Segment,
  Header,
  Table,
  Loader,
  Modal,
  Button,
  Dimmer,
  Dropdown,
  Search,
  Popup,
  Form,
  Message,
} from 'semantic-ui-react';
import { inject, observer } from 'mobx-react';
import { alertMessage } from '../../helper/alert-message';
import { postData } from '../../helper/dataService';

const getToken = () => window.localStorage.getItem('user');

@inject('assets')
@observer
class ManageUser extends Component {
  state = {
    loadingList: false,
    userAssetsLoading: false,
    showModal: false,
    showAddUserModal: false,
    userData: [],
    assetsList: [],
    assetOptions: [],
    selectedAssets: [],
    userAssets: [],
    userAssetsMain: [],
    selectedUserId: null,
    search: '',
    email: '',
    emailError: false,
    loadingEmailSubmit: false,
    loadingDownload: false,
  };

  componentDidMount() {
    this.fetchData();

    const assetList = this.props.assets.data;
    const assets = assetList
      .filter((item) => item.active)
      .map((item) => ({
        key: item.key,
        value: item.value,
        text: item.label,
      }));

    this.setState({
      assetsList: assets,
      assetOptions: assets,
    });
  }

  fetchData = () => {
    this.setState({ loadingList: true });
    axios
      .get(`${REGULAR_PATH}/organization/users?access_token=${getToken()}`)
      .then(({ data }) => {
        const { status, data: userData } = data;
        if (status === 'success') {
          this.setState({
            userData,
          });
          this.setState({ loadingList: false });
        }
      })
      .catch(() => {
        this.setState({ loadingList: false });
      });
  };

  handleGetUserAssets = (userId) => {
    this.setState({ userAssetsLoading: true });
    axios
      .get(
        `${REGULAR_PATH}/organization/users/${userId}/assets?access_token=${getToken()}`,
      )
      .then(({ data }) => {
        const userAssets = data.data;

        const updatedAssetsList = this.state.assetsList.filter(
          (asset) =>
            !userAssets.some((userAsset) => userAsset._id.$oid === asset.value),
        );

        this.setState({
          userAssets,
          userAssetsMain: userAssets,
          assetOptions: updatedAssetsList,
          userAssetsLoading: false,
          selectedUserId: userId,
        });
      })
      .catch(() => {
        this.setState({ userAssetsLoading: false });
      });
  };

  handleAssetSelect = (e, data) => {
    this.setState((prevState) => ({
      userAssets: [
        ...prevState.userAssets,
        {
          _id: { $oid: data.value[0] },
          name: data.options.find((option) => option.value === data.value[0])
            .text,
        },
      ],
      assetOptions: prevState.assetOptions.filter(
        (asset) => asset.value !== data.value[0],
      ),
    }));
  };

  handleDelete = (id) => {
    axios
      .put(
        `${REGULAR_PATH}/organization/users?access_token=${getToken()}`,
        JSON.stringify({
          user_oid: id,
        }),
      )
      .then(({ data }) => {
        this.setState((prevState) => ({
          userData: prevState.userData.filter((user) => user._id.$oid !== id),
        }));
      });
  };

  handleRemoveAsset = (id) => {
    const { userAssets, assetsList } = this.state;

    const updatedUserAssets = userAssets.filter(
      (asset) => asset._id.$oid !== id,
    );

    const finalAssetsList = assetsList.filter(
      (asset) =>
        !updatedUserAssets.some(
          (userAsset) => userAsset._id.$oid === asset.value,
        ),
    );

    this.setState({
      userAssets: updatedUserAssets,
      assetOptions: finalAssetsList,
    });
  };

  handleRemoveAll = () => {
    const { assetsList } = this.state;

    this.setState({
      userAssets: [],
      assetOptions: assetsList,
    });
  };

  handleAddAll = () => {
    const { assetOptions, userAssets } = this.state;

    const assets = [...userAssets];

    assetOptions.forEach((asset) => {
      const assetExist = userAssets.find(
        (userAsset) => userAsset._id.$oid === asset.value,
      );
      if (!assetExist) {
        assets.push({
          name: asset.text,
          _id: {
            $oid: asset.value,
          },
        });
      }
    });
    this.setState({
      assetOptions: [],
      userAssets: assets,
    });
  };

  handleCloseModal = () => {
    this.setState({ showModal: false });
    this.setState({ showAddUserModal: false });
    this.setState({
      email: '',
      emailError: false,
    });
  };

  handleUpdateUserAsset = () => {
    const { userAssets, selectedUserId, userData } = this.state;

    const assets_oid = userAssets.flatMap((item) => item._id.$oid);

    axios
      .put(
        `${REGULAR_PATH}/organization/users/${selectedUserId}/assets?access_token=${getToken()}`,
        JSON.stringify({
          assets_oid,
        }),
      )
      .then(({ data }) => {
        alertMessage(data.message, 'success');
        this.setState({
          userData: userData.map((user) => {
            if (user._id.$oid === selectedUserId) {
              return { ...user, assets: assets_oid.length };
            }
            return user;
          }),
        });
      });
  };

  handleAddUser = () => {
    const { email } = this.state;
    if (!this.validateEmail(email)) {
      this.setState({ emailError: true });
      return;
    } else {
      const data = {
        email,
      };
      this.setState({ loadingEmailSubmit: true });
      postData(
        `${REGULAR_PATH}/organization/users/request?access_token=${getToken()}`,
        JSON.stringify(data),
      )
        .then(({ data }) => {
          if (data.message === 'success') {
            alertMessage(
              'If user is registered, add request will be sent to this email.',
              'success',
            );
            this.setState({
              email: '',
              emailError: false,
              showAddUserModal: false,
            });
            this.setState({ loadingEmailSubmit: false });
          }
        })
        .catch(() => {
          this.setState({ loadingEmailSubmit: false });
        });
    }
  };

  handleDownload = () => {
    this.setState({ loadingDownload: true });

    axios
      .get(
        `${REGULAR_PATH}/organization/users/download_excel?access_token=${getToken()}`,
        { responseType: 'blob' },
      )
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'asset_list.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
        this.setState({ loadingDownload: false });
      })
      .catch((error) => {
        this.setState({ loadingDownload: false });
      });
  };

  validateEmail = (email) => {
    const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return pattern.test(email);
  };

  popupRef = createRef();

  closePopup = () => {
    // Simulate a click on the document body to close the popup
    document.body.click();
  };

  getOids = (arr) => arr.map((a) => a._id.$oid).sort();

  render() {
    const {
      loadingList,
      userData,
      showModal,
      selectedAssets,
      userAssets,
      assetOptions,
      userAssetsLoading,
      search,
      showAddUserModal,
      email,
      emailError,
      loadingEmailSubmit,
      userAssetsMain,
      loadingDownload,
    } = this.state;

    const disableSave =
      userAssets.length === userAssetsMain.length &&
      JSON.stringify(this.getOids(userAssets)) ===
        JSON.stringify(this.getOids(userAssetsMain));

    const isAuthorizedOrg = [
      '6020bcbf1d41c84da5bcb6a3',
      '660e2797faf103f4ae9b9c8d',
      '5ff93f231d41c82fc56f9e9f',
      '6992a801646454e3da6bd819',
    ].includes(window.localStorage.getItem('organization'));
    const isAdmin = window.localStorage.getItem('org_admin') === 'true';

    if (!isAuthorizedOrg || !isAdmin) {
      return <h2>You are not authorized person.</h2>;
    }

    if (loadingList) {
      return (
        <Dimmer active inverted>
          <Loader size='large'>Loading...</Loader>
        </Dimmer>
      );
    }

    const filteredList = userData.filter((item) =>
      Object.values(item).some(
        (value) =>
          value &&
          value.toString().toLowerCase().includes(search.toLowerCase()),
      ),
    );

    return (
      <>
        <Segment>
          <Segment>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <div>
                <Header as='h2'>Manage Users</Header>
              </div>
              <div style={{ display: 'flex', gap: 50 }}>
                <div style={{ width: 350 }}>
                  <Search
                    placeholder='Search here'
                    onSearchChange={(_, data) =>
                      this.setState({ search: data.value })
                    }
                    showNoResults={false}
                  />
                </div>
                <div>
                  <Button
                    primary
                    onClick={() => this.setState({ showAddUserModal: true })}
                  >
                    Add User
                  </Button>
                </div>
                <div>
                  <Button
                    primary
                    onClick={this.handleDownload}
                    loading={loadingDownload}
                    disabled={loadingDownload}
                  >
                    Download
                  </Button>
                </div>
              </div>
            </div>
          </Segment>
          <Table celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>No</Table.HeaderCell>
                <Table.HeaderCell>User name</Table.HeaderCell>
                <Table.HeaderCell>Email</Table.HeaderCell>
                <Table.HeaderCell>Mobile</Table.HeaderCell>
                <Table.HeaderCell>Assets</Table.HeaderCell>
                <Table.HeaderCell>Action</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {filteredList.map((user, index) => (
                <Table.Row key={user._id.$oid}>
                  <Table.Cell>{index + 1}</Table.Cell>
                  <Table.Cell>{user.name}</Table.Cell>
                  <Table.Cell>{user.email}</Table.Cell>
                  <Table.Cell>{user.mobile}</Table.Cell>
                  <Table.Cell>
                    <div>
                      <h3>{user.assets}</h3>
                    </div>
                  </Table.Cell>
                  <Table.Cell>
                    <div style={{ display: 'flex', gap: '5px' }}>
                      <Button
                        secondary
                        size='mini'
                        onClick={() => {
                          this.setState({ showModal: true });
                          this.handleGetUserAssets(user._id.$oid);
                        }}
                      >
                        Edit
                      </Button>
                      {!user.admin && (
                        <div>
                          <Popup
                            wide
                            trigger={
                              <Button
                                color='red'
                                size='mini'
                                content='Delete'
                                ref={this.popupRef}
                              />
                            }
                            on='click'
                          >
                            <div>
                              <p>Are you sure?</p>
                              <div style={{ display: 'flex', gap: 5 }}>
                                <Button
                                  color='red'
                                  size='mini'
                                  content='Yes'
                                  onClick={() =>
                                    this.handleDelete(user._id.$oid)
                                  }
                                />
                                <Button
                                  size='mini'
                                  color='blue'
                                  content='No'
                                  onClick={this.closePopup}
                                />
                              </div>
                            </div>
                          </Popup>
                        </div>
                      )}
                    </div>
                  </Table.Cell>
                </Table.Row>
              ))}
              {userData.length === 0 && (
                <Table.Row>
                  <Table.Cell colSpan='5' textAlign='center'>
                    No data found
                  </Table.Cell>
                </Table.Row>
              )}
            </Table.Body>
          </Table>
        </Segment>
        <Modal
          size='mini'
          open={showModal}
          closeIcon={true}
          onClose={this.handleCloseModal}
          closeOnDimmerClick={false}
          closeOnEscape={false}
        >
          <Modal.Header>Update Asset</Modal.Header>
          <Modal.Content>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div
                style={{
                  display: 'flex',
                  gap: 20,
                }}
              >
                <Dropdown
                  placeholder='Select Asset'
                  fluid
                  search
                  selection
                  multiple
                  options={assetOptions}
                  value={selectedAssets}
                  onChange={this.handleAssetSelect}
                  style={{ width: 500 }}
                />
                <div style={{ display: 'flex', gap: 8 }}>
                  <Button color='red' onClick={this.handleRemoveAll}>
                    Remove All
                  </Button>
                  <Button
                    color='red'
                    onClick={this.handleAddAll}
                    disabled={assetOptions.length === 0}
                  >
                    Add All
                  </Button>
                </div>
              </div>
              <Button
                onClick={this.handleUpdateUserAsset}
                style={{ width: 130 }}
                primary
                disabled={disableSave}
              >
                Save
              </Button>
            </div>

            {userAssetsLoading ? (
              <Dimmer active inverted>
                <Loader size='large'>Loading...</Loader>
              </Dimmer>
            ) : (
              <div style={{ marginTop: 20 }}>
                {userAssets.length > 0 ? (
                  <Table celled>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell>No</Table.HeaderCell>
                        <Table.HeaderCell>Name</Table.HeaderCell>
                        <Table.HeaderCell>Action</Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      {userAssets.map((asset, index) => (
                        <Table.Row key={asset._id.$oid}>
                          <Table.Cell>{index + 1}</Table.Cell>
                          <Table.Cell>{asset.name}</Table.Cell>
                          <Table.Cell>
                            <Button
                              color='red'
                              size='mini'
                              onClick={() =>
                                this.handleRemoveAsset(asset._id.$oid)
                              }
                            >
                              Remove
                            </Button>
                          </Table.Cell>
                        </Table.Row>
                      ))}
                    </Table.Body>
                  </Table>
                ) : (
                  <div style={{ textAlign: 'center' }}>
                    <h3>No assets assigned</h3>
                  </div>
                )}
              </div>
            )}
          </Modal.Content>
        </Modal>

        {/* Add user modal */}
        <Modal
          size='mini'
          open={showAddUserModal}
          closeIcon={true}
          onClose={this.handleCloseModal}
        >
          <Modal.Header>Add User</Modal.Header>
          <Modal.Content>
            <h4>
              <i>Note: User need to be registered first to add.</i>
            </h4>
            <Form onSubmit={this.handleAddUser} error={emailError}>
              <Form.Input
                required
                type='text'
                value={email}
                onChange={(e) => this.setState({ email: e.target.value })}
                error={emailError}
                placeholder='Enter email'
                style={{ width: '100%' }}
              />

              <Message error size='mini'>
                Please enter a valid email address.
              </Message>

              <Button
                positive
                type='submit'
                style={{ marginTop: 10 }}
                loading={loadingEmailSubmit}
              >
                Submit
              </Button>
            </Form>
          </Modal.Content>
        </Modal>
      </>
    );
  }
}

export default ManageUser;
